import React from "react";
import LoadingInput from "../../../../_components/LoadingInput";
import Text from "../../../../_components/Text";
import Button from "../../../../_components/Button";
import Modal from "../../../../_components/Modal";
import {
    getPaymentCategory,
    ToogleActivationCategory
} from "../../../../api/financial";

import SaveCategory from './createEditModal'
import { Table } from "react-bootstrap";

export default (props) => {
    const [categories, setCategories] = React.useState([])
    const [showModal, setShowModal] = React.useState(false)
    const [editData, setEditData] = React.useState(false)
    const [filterActive, setFilterActive] = React.useState(true)

    function _getCategories() {
        getPaymentCategory({ is_active: filterActive })
            .then(setCategories)
    }

    React.useEffect(() => {
        _getCategories()
    }, [filterActive])

    React.useEffect(() => {
        _getCategories()
    }, [])

    return (
        <div>
            <h2 className="text-center">
                Categorias de Pagamento
                <span
                    className={`badge badge-${filterActive ? "secondary" : "danger"}`}
                    style={{cursor: "pointer"}}
                    onClick={() => {
                        setFilterActive(!filterActive)
                    }}
                >
                    {filterActive ? "Ativos" : "Desativados"}
                </span>
            </h2>
            <div className="text-center">
                <button
                    className="btn btn-sm btn-primary"
                    onClick={() => setShowModal(true)}
                >
                    Criar
                </button>
            </div>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Nome</th>
                        <th>Status</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {categories.map((cat, _) => <tr>
                        <td>{_ + 1}</td>
                        <td>{cat.name}</td>
                        <td>{cat.is_active? "Ativo":"Desativado"}</td>
                        <td>
                            <button
                                className="btn btn-sm btn-primary"
                                onClick={() => {
                                    setEditData(cat);
                                    setShowModal(true)
                                }}>
                                Editar
                            </button>
                            <button className="btn btn-sm btn-danger" onClick={() => {
                                ToogleActivationCategory(cat.id)
                                    .then(() => {
                                        _getCategories()
                                        setShowModal(false)
                                    })
                            }}>
                                {cat.is_active ? "Desativar" : "Reativar"}
                            </button>
                        </td>
                    </tr>)}
                </tbody>
                <SaveCategory
                    show={showModal}
                    edit={editData}
                    onHide={() => {
                        _getCategories()
                        setEditData(false)
                        setShowModal(false)
                    }}
                />
            </Table>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/PaymentCategory/list.jsx